function at(array, index) {
    const length = array.length;
    const k = index >= 0 ? index : length + index;
    if (k < 0 || k >= length) {
        return undefined;
    }
    return array[k];
}
export function sampleSchedule() {
    const elements = [...document.querySelectorAll('.schedule-block')];
    let elementLength = 0;
    if (globalThis.matchMedia('screen and (min-width: 1200px)').matches) {
        elementLength = (elements.length - 6) / 4;
    }
    else if (globalThis.matchMedia('screen and (max-width: 1199px)').matches) {
        elementLength = (elements.length - 6) / 2;
    }
    const decimal = elementLength % 1;
    if (globalThis.matchMedia('screen and (min-width: 1200px)').matches) {
        switch (decimal) {
            case 0.25: {
                at(elements, -1)?.classList.add('class25');
                break;
            }
            case 0.5: {
                at(elements, -1)?.classList.add('class50');
                at(elements, -2)?.classList.add('class50');
                break;
            }
            case 0.75: {
                at(elements, -1)?.classList.add('class75');
                at(elements, -2)?.classList.add('class75');
                at(elements, -3)?.classList.add('class75');
                for (let index = elements.length - 3; index < elements.length; index += 3) {
                    jQuery(elements.slice(index, index + 3)).wrapAll("<div class='three-elements'></div>");
                }
                break;
            }
        }
    }
    else if (globalThis.matchMedia('screen and (max-width: 1199px)').matches &&
        globalThis.matchMedia('screen and (min-width: 768px)').matches &&
        decimal === 0.5) {
        at(elements, -1)?.classList.add('class25');
    }
}
export function sampleScheduleResize() {
    const elements = document.querySelectorAll('.schedule-block');
    const threeElements = document.querySelectorAll('.three-elements .schedule-block');
    if (threeElements.length > 0) {
        jQuery(threeElements).unwrap();
    }
    for (const element of elements) {
        element.classList.remove('class25', 'class50', 'class75');
    }
    sampleSchedule();
}
